import "@expert/theme/global.css";
import { FeedbackContextProvider } from "@asurion-core/expert-workspace-feedback";
import { ContentfulClientProvider } from "@expert/contentful";
import { GlobalThemeProvider } from "@expert/theme";
import "@mantine/notifications/styles.css";
import { Notifications } from "@mantine/notifications";
import { createClient } from "contentful";
import { RouterProvider } from "react-router";

import { AuthenticationProvider } from "./auth";
import { ReactQueryClient } from "./providers";
import { RoutePath, router } from "./routes";
import { env } from "./utils/env";

const contentfulClient = createClient(env.contentful);

export function App() {
    return (
        <GlobalThemeProvider>
            <AuthenticationProvider redirectPath={RoutePath.Home}>
                <ContentfulClientProvider client={contentfulClient}>
                    <ReactQueryClient>
                        <Notifications
                            limit={1}
                            position="top-center"
                            zIndex="var(--mantine-priority-highest)"
                            data-testid="notifications-center"
                        />
                        <FeedbackContextProvider getExpertFeedbackUrl={() => env.expertFeedbackUrl}>
                            <RouterProvider router={router} />
                        </FeedbackContextProvider>
                    </ReactQueryClient>
                </ContentfulClientProvider>
            </AuthenticationProvider>
        </GlobalThemeProvider>
    );
}
